import React, { useState } from 'react';
import { Breadcrumb } from 'react-bootstrap';
import { NavBarHeader } from '../../../components/navbar';
import styles from './metor28.module.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCheckDouble, faCircle, faDownload } from '@fortawesome/free-solid-svg-icons';
import { FooterWeb } from '../../../components/footer';
import styles1 from '../../../components/footer/footer.module.css';
import ProductCustomer from '../../../components/productcustomer';
const Metor28 = () =>{
  const[opens,setOpens] = useState<string>('');
const removeDownload = () =>{
  setOpens('');
}
  const download =() =>{
    setOpens('/images/productDataSheet/Metor-28-Datasheet.pdf');
  }

    return(<><NavBarHeader></NavBarHeader>
        <section className={styles.breadcrumbs}>
            <div className="container">

                <div className="d-flex justify-content-between align-items-center">
                    <h2 className={styles.headingH2}>METOR 28</h2>
                    <Breadcrumb className="d-none d-sm-block">
                        <Breadcrumb.Item href="#">Home</Breadcrumb.Item>
                        <Breadcrumb.Item href="#">Products</Breadcrumb.Item>
                        <Breadcrumb.Item active>metor metal detectors</Breadcrumb.Item>
                        <Breadcrumb.Item active>METOR 28</Breadcrumb.Item>
                    </Breadcrumb>
                </div>

            </div>
        </section>
        <section id="about" className="about">
      <div className="container aos-init aos-animate" data-aos="fade-up">

   

        <div className="row my-4">
          <div className="col-lg-4 text-center">
           
            <img src="/images/products/metor-28.jpg" className="img-fluid pt-5" alt=""/><br/><br/>
            <a href="#" onClick={download} style={{"margin":"0 auto"}} className="btn btn-primary btn-lg"><FontAwesomeIcon icon={faDownload}  /> Data Sheet</a></div>
          
          <div className="col-lg-8 pt-4 pt-lg-0 content">
            <p className={styles.productdescr}>Hand-held metal detectors are an integral part of the physical security screening process. With the Metor 28, we have designed a unit that benefits security personnel as well as the person being scanned. Our unique angled design allows you to thoroughly scan an individual, while keeping your hand away from their body.</p>
            <div className="row">
              <div className="col-lg-12">
              <ul className={`${styles.productslist} list-group list-group-flush`}>
    <li className="list-group-item"><FontAwesomeIcon icon={faCheckDouble} className="text-primary"  /> <span>The circular opening assists in pinpointing metal objects</span></li>
    <li className="list-group-item"><FontAwesomeIcon icon={faCheckDouble}  className="text-primary" /><span> Comfortable handle for easy control and grip</span></li>
    <li className="list-group-item"><FontAwesomeIcon icon={faCheckDouble}  className="text-primary" /><span>  Lightweight 260 g (9.3 oz.) with battery</span></li>
    <li className="list-group-item"><FontAwesomeIcon icon={faCheckDouble}  className="text-primary" /><span> Wrist strap</span></li>
     </ul>    
 
              </div>
    
            </div>
   
          </div>
        </div>

      </div>
    </section>
    <section>
        <div className="container">
            <div className="row">
                    <div className="offset-md-2 col-lg-2 col-md-2  col-12">
                    <div className={`${styles.circleIcon}`}>
                
                        <FontAwesomeIcon icon={faCheck} className="text-center"  color="white" size="2x"  />
                        
                    </div>
                    <p className={`${styles.circleIconp} text-center mt-3`}>Unique <br/> Angled <br/> Design</p>
                    </div>
                    <div className="col-lg-2  col-md-2 col-12">
                    <div className={`${styles.circleIcon} ${styles.circleIconp}`}>
                
                        <FontAwesomeIcon icon={faCheck} className="text-center"   color="white" size="2x"  />
                        
                    </div>
                    <p className={`${styles.circleIconp} text-center mt-3`}>Rugged <br/>Construction</p>
                    </div>
                    <div className="col-lg-2  col-md-2 col-12">
                    <div className={`${styles.circleIcon} ${styles.circleIconp}`}>
                
                        <FontAwesomeIcon icon={faCheck} className="text-center"   color="white" size="2x"  />
                        
                    </div>
                    <p className={`${styles.circleIconp} text-center mt-3`}>Detects<br/>All Metals</p>
                    </div>
                    <div className="col-lg-2  col-md-2 col-12">
                    <div className={`${styles.circleIcon} ${styles.circleIconp}`}>
                
                        <FontAwesomeIcon icon={faCheck} className="text-center"   color="white" size="2x"  />
                        
                    </div>
                    <p className={`${styles.circleIconp} text-center mt-3`}>LIGHTWEIGHT</p>
                    </div>
            </div>
            <div className="row">
              <div className="col-lg-6 col-md-6 col-12">
              <h3 className={styles.aboutH3}>Detection</h3>
              <p  className={styles.listPara}>Detects all metals, both ferrous and non-ferrous.</p>
              </div>
              <div className="col-lg-6 col-md-6 col-12">
              <h3 className={styles.aboutH3}>Operation</h3>  
              <p   className={styles.listPara}>
              3-way push-button operation: On/Off/Momentary. </p>
               </div>
                
            </div>
            <div className="row">
              <div className="col-lg-6 col-md-6 col-12">
              <h3 className={styles.aboutH3}>SENSITIVITY </h3>
              <p  className={styles.listPara}> Programmable sensitivity levels:</p>
              <p  className={styles.listPara}> Level 1: Small handguns and knives </p>
              <p  className={styles.listPara}> Level 2: Razor blades, handcuff keys </p>
              <p  className={styles.listPara}> Level 3: 22 caliber bullet, metal shanks</p>
              </div>
              <div className="col-lg-6 col-md-6 col-12">
              <h3 className={styles.aboutH3}>Battery</h3>  
              <ul  className={styles.listPara}>
              <li>NiMH rechargeable battery or 9V alkaline battery.</li>
              <li>Low battery indicator, both visual and audible.</li></ul>
                </div>
            </div>
            <div className="row">
              <div className="col-lg-6 col-md-6 col-12">
              <h3 className={styles.aboutH3}>Alarm</h3>
              <ul  className={styles.listPara}>
              <li>Audible and visual alarm indication.</li>
              <li>Optional Headset.</li>
              <li>Rugged Construction</li>
              <li>High impact resistant ABS case.</li></ul>
              </div>
              <div className="col-lg-6 col-md-6 col-12">
              <h3 className={styles.aboutH3}>Safety</h3>  
              <p  className={styles.listPara}>
              Very long operating time with two AA-batteries, (rechargeable NiMH, disposable alkaline or lithium battery). Low battery and empty battery warnings.</p>
            </div>
                
            </div>
            <section id="about" className="about my-3">
            <div className="section-title1 my-5"><h2>SPECIFICATION</h2>
            <div className="row my-5">
              <div className="col-lg-3">
              <h5>DIMENSIONS (BODY)</h5>
              <p  className={styles.listPara1}>410 x 140mm (16.35 x 5.5 in)</p>
              </div>
              <div className="col-lg-3">
              <h5>DIMENSIONS (GRIP)</h5>
              <p  className={styles.listPara1}>33 x 33mm (1.3 x 1.3 in).</p>
              </div>
              <div className="col-lg-4">
              <h5>WEIGHT (BATTERY INCLUDED)</h5>
              <p  className={styles.listPara1}>260 g (9.3 oz.) with battery</p>
              </div>
              
            </div>
            </div>

            </section>
        </div>
    </section>
    <footer id={styles1.footer}>
        <div className={styles1.footerTop}>
          <div className="container">
            <div className="row">
              <FooterWeb></FooterWeb>
              <div className={styles1.container}>
                <div className={styles1.copyright}>
                  © 2022 <strong><span>ECIL Rapiscan Limited.</span></strong> All Rights Reserved
                </div>

              </div>
            </div>
          </div>
        </div>
      </footer>
      {opens && <ProductCustomer removeDownload={removeDownload} shows={opens} product="METOR 28"></ProductCustomer>}  
        </>)
};

export default Metor28;